import { store } from '../../store';

export default async (to: any, from: any, next: Function) => {
    if (to.matched.some((record: any) => !!record.meta.guest)) {
        return handleAuthGuestRoute(next);
    }

    if (to.matched.some((record: any) => record.meta.requiresAuth)) {
        let requiredVerification = to.matched.some(
            (record: any) => record.meta.requiresVerification,
        );
        let requiresNoPendingVerification = to.matched.some(
            (record: any) => record.meta.requiresNoPendingVerification,
        );

        return handleAuthProtectedRoute(
            to,
            next,
            requiredVerification,
            requiresNoPendingVerification,
        );
    }

    next();
};

async function handleAuthGuestRoute(next: Function) {
    if (await isLoggedIn()) {
        next({ name: 'account' });
        return;
    }
    next();
}

async function handleAuthProtectedRoute(
    to: any,
    next: Function,
    requiredVerification: boolean = false,
    requiresNoPendingVerification: boolean = false,
) {
    if (!(await isLoggedIn())) {
        // Dupa login se intoarce aici (ex: confirmarea telefonului venind din site)
        next({ name: 'login', query: { redirect: to.fullPath } });
        return;
    }

    if (requiredVerification) {
        if (await isVerified()) {
            next();
        } else if (await isPhoneConfirmationPending()) {
            next({ name: 'account-verify-phone' });
        } else if (store.getters.getVerificationInProgress) {
            next({ name: 'account-verify-pending' });
        } else {
            next({ name: 'account-verify' });
        }
    } else if (requiresNoPendingVerification) {
        if (await isVerified()) {
            next({ name: 'account' });
        } else if (await isPhoneConfirmationPending()) {
            // Telefonul se confirma inaintea selfie-ului si a buletinului
            next({ name: 'account-verify-phone' });
        } else if (store.getters.getVerificationInProgress) {
            next({ name: 'account-verify-pending' });
        } else {
            next();
        }
    } else {
        next();
    }
}

let waitAsync = async function(millis: number) {
    return new Promise<void>((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, millis);
    });
};

async function isLoggedIn() {
    let checkingSession = store.getters.getCheckingSession;

    if (checkingSession) {
        while (checkingSession) {
            await waitAsync(100);

            checkingSession = store.getters.getCheckingSession;
        }
    }

    return store.getters.getLoggedInState;
}

async function isVerified() {
    return store.getters.getLoggedInUser.verified;
}

async function isPhoneConfirmationPending() {
    return !!store.getters.getLoggedInUser.phoneConfirmationPending;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/router/guards/auth.ts